import { DropdownOption } from "PFComponents/dropdown/dropdown";
import DropdownButton from "PFComponents/dropdown/dropdown_button";
import DownArrowIcon from "PFIcons/down_arrow.svg";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { capitalize } from "underscore.string";

import css from "./bulk_actions_header.module.scss";
import BulkSelect from "./bulk_select";

type IItem = {
  id: number;
};
type IProps = {
  allItems: IItem[];
  selectedItems: IItem[];
  setSelectedItems: Dispatch<
    SetStateAction<
      {
        id: number;
      }[]
    >
  >;
  actions: DropdownOption[];
};

const BulkActionsHeader = ({ allItems, selectedItems, setSelectedItems, actions }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={css.root}>
      <span className={css.bulkSelectWrapper}>
        <BulkSelect
          disabled={allItems.length === 0}
          className={css.bulkSelect}
          allItems={allItems}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
        />
        {`${selectedItems.length} ${t(selectedItems.length === 1 ? "item" : "items")} ${t("selected")}`}
      </span>
      {/* @ts-ignore-line */}
      <DropdownButton
        buttonKind="secondary"
        buttonStyle={{ borderRadius: 5 }}
        options={actions}
        disabled={selectedItems.length === 0}
        handleChange={(fn) => fn && fn(selectedItems)}
      >
        <DownArrowIcon height={20} />
        {capitalize(t("action"))}
      </DropdownButton>
    </div>
  );
};

export default BulkActionsHeader;
